// removed by extract-text-webpack-plugin
module.exports = {"block":"j6kqZ5GFXEVjNhlxyIIhr","map":"_3WN0aXCpvRc6rfq0DCAt6h","address":"_3QQgBN8Uk6JOUStZqb-r93","icon":"xmLCWOBgxV6kfCkBunMsc","marker":"_3YTNSTejoGZ5EkjY12zsRL","iconDone":"El5u8bFfIDWnl7fnQnEHH","label":"_2mLGdPWv2vjIMtCB2_0Wl9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MapBlock/MapBlock.module.scss
// module id = 786
// module chunks = 0